import { createContext } from "react";

export const BookmarkContext = createContext();
